<template>

	<footer id="footer" class="footer with-border">
        
        <div class="footer-top">
            <div class="footer-top-content">
                <div class="d-flex row align-items-center">
                    <div class="footer-top-content-text col-md-8 col-xl-9 col-12" v-if="slug!='iacr'">Connect with us</div>
	                    <div class="footer-top-content-links d-flex col-md-4 col-xl-3 col-12 justify-content-md-between justify-content-start">
	                            
	            		<a href="https://twitter.com/iarcwho" target="_blank" title="Twitter" class="social-icons-block-item footer-top-content-link-item twitter" v-if="slug!='iacr'">
	            			<img class="twitter" alt="twitter">
				        </a>
			            
			            <a href="https://www.youtube.com/channel/UCw1sEvFsKqLLRmKQdaOSs9A" target="_blank" title="Youtube" class="social-icons-block-item footer-top-content-link-item youtube" v-if="slug!='iacr'">
				            <img class="youtube" alt="youtube">
				        </a>
			            
			            <a :href="linkedin_url" target="_blank" title="Linkedin" class="social-icons-block-item footer-top-content-link-item linkedin" v-if="slug!='iacr'">
				            <img class="linkedin" alt="linkedin">
				        </a>
			            
			            <a href="https://www.iarc.who.int/iarc-rss-feeds/" title="RSS" class="social-icons-block-item footer-top-content-link-item rss" v-if="slug!='iacr'">
				            <img class="rss" alt="rss">
				        </a>
				        
				        <a href="javascript:window.print()" title="Print" class="social-icons-block-item footer-top-content-link-item print">
				        	<img class="print" alt="print">
				    	</a>

			            <a href="https://www.facebook.com/Je-soutiens-la-recherche-sur-le-cancer-102631568744068/" target="_blank" title="Facebook" class="social-icons-block-item footer-top-content-link-item facebook" v-if="slug!='iacr'">
			            	<img class="facebook" alt="facebook">
			        	</a>
		                
		                <a href="https://www.instagram.com/jesoutienslecirc/?hl=fr" target="_blank" title="Instagram" class="social-icons-block-item footer-top-content-link-item instagram" v-if="slug!='iacr'">
			            	<img class="instagram" alt="instagram">
			        	</a>
			    
			            <a href="https://videos.iarc.fr/" target="_blank" title="IARC TV" class="social-icons-block-item footer-top-content-link-item tv" v-if="slug!='iacr'">
			            	<img class="tv" alt="tv">
			        	</a>

                    </div>
                </div>
            </div>
        </div>

        <div class="footer-menu">
            <div class="container-fluid full-width">
                <div class="footer-menu-row d-flex row justify-content-between align-items-start flex-wrap">
                    <div class="footer-menu-row-center justify-content-start flex-wrap d-flex col-md-8 col-lg-8 col-xl-9 col-12 order-md-1 order-2">
                        <div class="menu-item menu-item-type-post_type menu-item-object-page" v-for="nav in footer_nav">
                        	<a :href="nav.url" :title="nav.name" target="_blank" v-if="nav.url != undefined ">
                        		{{ nav.name }}
                        	</a>
                        	<router-link :to="{ name : nav.route , params : ( nav.params != undefined ) ? nav.params : { lang : 'en' } }" v-if="nav.url == ''">
                        		{{ nav.name }}
                        	</router-link>
                        </div>
                    </div>
                    <div class="footer-menu-row-contact d-flex flex-column justify-content-between align-self-stretch pt-sm-5 pt-md-4 pl-xs-auto col-md-3 col-lg-3 col-xl-2 col-6 order-md-2 order-3">
                        <div class="footer-menu-row-contact-top d-flex flex-column mt-0">
                            <div class="footer-menu-row-contact-title mb-1 mb-md-0">
                                Contact us
                            </div>
            			    
            			    <div class="footer-menu-row-contact-link footer-menu-row-contact-link-address mt-2 mt-md-3 mb-1 mb-md-0">
			        			25 avenue Tony Garnier CS 90627 69366 LYON CEDEX 07 France			    
			        		</div>
    			            
    			            <a href="tel:+33 (0)4 72 73 84 85" class="footer-menu-row-contact-link mt-2 mt-md-3 mb-1 mb-md-0 d-flex align-items-start">
                    			+33 (0)4 72 73 84 85               
                			 </a>

                			 <a href="mailto:iacr@iacr.who.int" class="footer-menu-row-contact-link mt-2 mt-md-3 mb-1 mb-md-0 d-flex align-items-start" v-if="slug=='iacr'">
                    			iacr@iacr.who.int       
                			 </a>
                        </div>
                    </div>
                    <div class="footer-arrow d-flex justify-content-end col-md-1 order-md-3 order-1">
                        <a href="#"><img alt="up"></a>
                    </div>
                </div>
            </div>
        </div>

        <div>
        	<!-- common -->
            <div class="d-flex flex-wrap row align-items-center justify-content-between justify-content-sm-center copyright" v-if="slug!='iacr'">
                <div class="d-flex col-md-8 col-lg-8 col-xl-9 col-12 pl-0">
                    <a href="https://www.iarc.who.int/copyright-notice/" class="footer-copyright" target="_blank" v-if="this.show_copyright">
                    © IARC 1965-{{ year }}&nbsp;— All Rights Reserved</a>
                </div>
                <div class="d-flex col-md-4 col-lg-4 col-xl-3 col-12 copyright-bottom" v-if="this.show_copyright">
                    <ul id="menu-copyright-menu" class="copyright-menu">
                    	<li class="menu-item menu-item-type-custom">
                    		<a target="_blank" href="http://publications.iarc.fr/Terms-Of-Use">Terms of use</a>
                    	</li>
						<li class="menu-item menu-item-type-post_type">
							<a href="https://www.iarc.who.int/privacy-policy/" target="_blank">Privacy Policy</a>
						</li>
					</ul>                
				</div>
            </div>

            <!-- IACR -->
            <div class="d-flex flex-wrap row align-items-center justify-content-between justify-content-sm-center copyright" v-if="slug=='iacr'">
                <div class="d-flex col-md-8 col-lg-8 col-xl-9 col-12 pl-0">
                    <a href="#" class="footer-copyright">
                    © {{ year }}&nbsp;— All Rights Reserved - The International Association of Cancer Registries</a>
                </div>
                <div class="d-flex col-md-4 col-lg-4 col-xl-3 col-12 copyright-bottom">
                    <ul id="menu-copyright-menu" class="copyright-menu">
                    	
						<li class="menu-item menu-item-type-post_type">
							<a href="/privacy-policy/">Privacy Policy</a>
						</li>
					</ul>                
				</div>
            </div>

        </div>
        

	</footer>

</template>

<script>

import projects_json from './assets/data/projects.json'

export default {
	name : 'IarcFooter', 
	props : {

	} , 
	data : function(){	
	  	return {
			year : new Date().getFullYear() ,

	        footer_nav : projects_json.filter((proj)=>proj!=undefined&&proj.is_footer==true).map((r)=>{
	          // r.url = r.url
	          return r ; 
	        }),
	        slug : (this.$store.state ?? this.$store.state.const.project_slug ) , 
	        show_copyright : true ,  //( this.$store.state.const.project_slug != 'iacr') 
   			linkedin_url : "https://www.linkedin.com/company/102821/"
   		}
	},
	mounted(){
		if ( this.$store.state.const != undefined && this.$store.state.const.project_slug == 'iacr')
		{
			this.footer_nav = this.$store.state.const.navigation.map( n => {
				n.name = n.label ; 
				let r = this.$router.options.routes.find(r => r.name === n.route)
				return n 
			})

			this.linkedin_url = "https://www.linkedin.com/company/102821/" 
		}  
	}
}
</script>

<style lang="scss">

.iarc_layout footer .menu-item:not(.menu-item-mobile) a.router-link-active.router-link-exact-active, 
.iarc_layout footer .menu-item:not(.menu-item-mobile) a.router-link-active{

	border-bottom: none ; 

}

#footer .footer-menu .menu-item a{
	text-decoration: none ; 
}

</style>